module.exports = __webpack_public_path__ + "img/icon-flyline-chart.fa270143.png";